import { Typography } from 'antd';
import { useEffect, useRef } from 'react';
import React from 'react';
import { useAppDispatch } from '../../../store/app.hooks';
import { Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import { clearDataRetentionLog } from '../../../store/master/dataRetentionLog/dataRetentionLog.reducer';
import MainTable from './MainTable/index';

// Run history of dbo.uspM360_DataRetention: one '(run)' row per run plus one row per step. Read-only.
const DataRetentionLog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(clearDataRetentionLog());
    };
  }, []);

  return (
    <div className="sqlServer">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.DataRetentionLog} />
        </h4>
        <Typography.Text type="secondary">
          History of data retention runs, newest first. Each run starts with a Run Summary row
          (totals for the run), followed by one row per table: rows deleted (or counted, for a dry
          run), the cutoff date used, and any error.
        </Typography.Text>
      </div>
      <div className="main-card">
        <MainTable ref={dataTableRef} />
      </div>
    </div>
  );
};

export default DataRetentionLog;
